import axios from 'axios';

export default {
  name: 'Downloader',
  methods: {
    /*
     * Makes an AJAX request to the given URL. The file which is returned as response is downloaded immediately.
     * The file name is required to download the file.
     */
    async download(url, fileName) {
      const response = await axios.get(url, {
        responseType: 'blob',
        timeout: 30000,
      });
      this.getDownloadContent(response, fileName);

      return response;
    },
    async downloadWithParams(params) {
      const response = await axios({
        url: params.url,
        method: params.method ? params.method : 'get',
        data: params.data,
        responseType: 'blob',
        timeout: 30000,
      });
      this.getDownloadContent(response, params.fileName);

      return response;
    },
    getDownloadContent(response, fileName) {
      const objectUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = objectUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    },
  },
};
